var Curriculog = Curriculog || {};

Curriculog.UserRights = (function ($, _, Backbone, UserRights) {

    UserRights = Curriculog.CurriculogModel.extend({
        urlRoot: '/rest/userrights',
    });
    return UserRights;

})($, _, Backbone, Curriculog.UserRights || {});
